export const SCROLL_DELAY_MS = 400;

export const SIGNED_DOCUMENTS_MERGE_MESSAGE = "Signed documents can't be merged";
